import Components from './../Component';

const FOCUSABLE_ELEMENTS = [
  'a[href]',
  'area[href]',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])',
  'button:not([disabled]):not([aria-hidden])',
  'iframe',
  'object',
  'embed',
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])'
]

export default class Search extends Components {

  constructor($) {
    super($);
    this.lastSuggestion = '';
    this.lastSearch = '';
    this.host = '';
    this.trigger = null;

    try {
      if (main_host) {
        this.host = main_host;
      }
    } catch (e) {
      //
    }

    this.lang = $('body').attr('data-language');


  }

  init(index, element) {

    this.$('.header-search .btn').on('click', function (e) {
      this.trigger = this.$(e.currentTarget);
      this.open(index, element);
    }.bind(this));

    this.$('input.search_trigger').on('click', function (e) {
      if (this.currentBreakpoint != 'mobile' && this.currentBreakpoint != 'tablet') {
        this.trigger = this.$(e.currentTarget);
        this.open(index, element);
      }
    }.bind(this));

    this.$(element).find('.close-search').on('click', function (e) {
      this.close(index, element);
    }.bind(this));

    this.$(element).find('.close-search').on('keyup', function (e) {
      if (e.keyCode == 13) {
        this.close(index, element);
      }
    }.bind(this));

    this.$(document).keydown(function (e) {
      if (e.keyCode == 27 && this.$(element).hasClass('open')) {
        this.close(index, element);
      }
      if (e.keyCode === 9){
        this.retainFocus(e) // tab
      }
    }.bind(this));


    //SEARCH
    var timeout;
    this.$(element).find('input').on('keyup', function (e) {

      if (this.$(element).find('input.search-input').val() == '') {
        this.$('.placeholder').show();
      } else {
        this.$('.placeholder').hide();
      }

      if (this.lastSearch != this.$(element).find('input.search-input').val()) {
        this.lastSearch = this.$(element).find('input.search-input').val();
        clearTimeout(timeout);
        if (this.$(element).find('input.search-input').val().length > 0) {
          if (this.lastSuggestion.indexOf(this.$(element).find('input.search-input').val()) != 0) {
            this.$(element).find('.autocompletion').val('');
          }
          timeout = setTimeout(function () {
            this.search(element, this.$(element).find('input.search-input').val());
          }.bind(this), 500);
        } else {
          this.$(element).find('.autocompletion').val('');
          this.$(element).find('.search-results').html('');
          this.stopLoading(element);
        }
      }
    }.bind(this));

    this.masonry(element);

    //Check if #search-exists url and open search
    if (window.location.hash.indexOf('search-') > -1) {
      this.open(index, element);
    }

  }

  open(index, element) {
    this.$(element).addClass('open');
    this.$('body').addClass('modal-open');
    this.$(element).find('input.search-input').focus();

    /*GET HASH*/
    if (window.location.hash.indexOf('search-') > -1) {
      var search_hash = decodeURIComponent(window.location.hash.substr(8));
      this.$(element).find('input.search-input').val(search_hash);
      this.lastSearch = search_hash;
      this.search(element, search_hash);
      this.$('.placeholder').hide();
    }

    //this.setFocusToFirstNode();

  }

  close(index, element) {
    this.$(element).removeClass('open');
    this.$('body').removeClass('modal-open');
    this.$(this.trigger).focus();

    //Remove hash 'search-' from url
    if (window.location.hash.indexOf('search-') > -1) {
      window.location.hash = '';
    }
  }

  html_escape(s, attribute) {
    if (s == null) {
      return '';
    }
    s = String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    if (attribute) {
      s = s.replace(/"/g, '&quot;');
    }
    return s;
  };

  search(element, search) {

    window.location.hash = '#search-' + this.html_escape(search);

    this.startLoading(element);
    this.$('.search-results').html('');


    console.log('ici');

    this.$.getJSON(this.host + ((this.lang != 'fr') ? ('/' + this.lang) : '')  + '/search_autocomplete?q=' + (search.toLowerCase()), function (data) {

      if (data.suffix) {
        if (data.suffix.indexOf('.') == 0) {
          data.suffix = '';
        }
      }


      //this.lastSuggestion = '';
      if (data.suffix && data.suffix != '') {
        if (data.input != '') {
          this.lastSuggestion = search + data.suffix;
          this.$(element).find('.autocompletion').val(search + data.suffix);
          this.$(element).find('.do-you-mean').text('');
        } else {
          this.$(element).find('.do-you-mean').html('Voulez-vous dire <a href="#" class="suffix">' + data.suffix + '<a> ?');

          this.$(element).find('.do-you-mean .suffix').on('click', function (e) {
            this.$('.placeholder').hide();
            this.$(element).find('input.search-input').val(data.suffix);
            this.lastSearch = data.suffix;
            this.search(element, data.suffix);
            e.preventDefault();
            return false;
          }.bind(this));

          this.$(element).find('.autocompletion').val('');
        }

        if (this.lastSearch == search) {

          var suffix = '';
          if (data.input != '') {
            suffix = '+' + search + data.suffix;
          }

          this.$.getJSON(this.host + ((this.lang != 'fr') ? ('/' + this.lang) : '') + '/search?json=1&q=' + search + suffix, function (data) {
            if (this.lastSearch == search) {
              this.$(element).find('.search-results').html(data.html);
              this.masonry(element);
              setTimeout(function () {
                this.stopLoading(element);
                this.research = false;
              }.bind(this), 10);
            }
          }.bind(this));
        }

      } else {
        this.$(element).find('.autocompletion').val('');
        this.$(element).find('.do-you-mean').val('');

        this.$.getJSON(this.host + ((this.lang != 'fr') ? ('/' + this.lang) : '')  + '/search?json=1&q=' + search, function (data) {
          if (this.lastSearch == search) {
            this.$(element).find('.search-results').html(data.html);
            this.masonry(element);
            setTimeout(function () {
              this.stopLoading(element);
            }.bind(this), 10);
          }
        }.bind(this));
      }


    }.bind(this));
  }

  masonry(element) {

    jQuery('.masonry').masonry({
      // options
      itemSelector: '.masonry-card',
      percentPosition: true,
      columnWidth: '.masonry-card',
      //gutter: 30
    });

    this.$('.masonry').imagesLoaded()
      .progress(function (instance, imag) {
        jQuery('.masonry').masonry({
          // options
          itemSelector: '.masonry-card',
          percentPosition: true,
          columnWidth: '.masonry-card',
          //gutter: 30
        });
      });
  }

  startLoading(element) {
    this.$('body').addClass('searching');
    this.$('.search-content .no-results').removeClass('show');
  }

  stopLoading(element) {
    if (this.$('.search-results .masonry-card').length == 0 && this.$(element).find('input.search-input').val() != '') {
      this.$('.search-content .no-results').addClass('show');
    } else {
      this.$('.search-content .no-results').removeClass('show');
    }
    this.$('body').removeClass('searching');

  }


  getFocusableNodes () {
    const nodes = document.getElementById('search-dialog').querySelectorAll(FOCUSABLE_ELEMENTS);
    return Array(...nodes);
  }

  /**
   * Tries to set focus on a node which is not a close trigger
   * if no other nodes exist then focuses on first close trigger
   */
  setFocusToFirstNode () {

    const focusableNodes = this.getFocusableNodes()

    // no focusable nodes
    if (focusableNodes.length === 0) return

    // remove nodes on whose click, the modal closes
    // could not think of a better name :(
    const nodesWhichAreNotCloseTargets = focusableNodes.filter(node => {
      //return !node.hasAttribute(this.config.closeTrigger)
      return true
    })

    setTimeout(function(){
      if (nodesWhichAreNotCloseTargets.length > 0) { nodesWhichAreNotCloseTargets[0].focus() }
      if (nodesWhichAreNotCloseTargets.length === 0) { focusableNodes[0].focus() }
    }, 100);

  }

  retainFocus (event) {
    let focusableNodes = this.getFocusableNodes();

    // no focusable nodes
    if (focusableNodes.length === 0) return

    /**
     * Filters nodes which are hidden to prevent
     * focus leak outside modal
     */
    focusableNodes = focusableNodes.filter(node => {
      return (node.offsetParent !== null)
    })

    if (focusableNodes.length === 0) return

    // if disableFocus is true
    if (!document.getElementById('search-dialog').contains(document.activeElement)) {
      focusableNodes[0].focus();
    } else {
      const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
      let newFocusedItemIndex = focusedItemIndex;

      if (event.shiftKey) {
        newFocusedItemIndex--;
      }
      if (!event.shiftKey) {
        newFocusedItemIndex++;
      }
      if (newFocusedItemIndex < 0){
        newFocusedItemIndex = focusableNodes.length - 1;
      }
      if (newFocusedItemIndex > focusableNodes.length - 1){
        newFocusedItemIndex = 0;
      }

      focusableNodes[newFocusedItemIndex].focus()
      event.preventDefault()
    }
  }



}
